import { Typography, useMediaQuery } from '@mui/material';
import StatusMarkerIcon from '../../../../../components/StatusMarkerIcon';
import DefaultButton from '../../../../../components/Accessibility/DefaultButton';
import { useAccessibility } from '../../../../../Store/contexts/AccessibilityContext';
import { TranscricaoTimelineStep } from '../../utils/transcricaoHistoricoUtils';

interface Props {
  steps: TranscricaoTimelineStep[];
  erro?: string | null;
  onResolver?: () => void;
}

const stateClassName: Record<TranscricaoTimelineStep['state'], string> = {
  completed: 'transcricao-timeline-step--completed',
  current: 'transcricao-timeline-step--current',
  pending: 'transcricao-timeline-step--pending',
};

const TranscricaoHistoricoTimeline: React.FC<Props> = ({ steps, erro, onResolver }) => {
  const accessibility = useAccessibility();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const markerSize = isMobile ? 'sm' : 'md';

  if (erro) {
    return (
      <Typography style={accessibility.textStyleAccessibility} className="transcricao-detalhe-erro">
        {erro}
      </Typography>
    );
  }

  if (!steps.length) {
    return (
      <Typography
        style={accessibility.textStyleAccessibility}
        className="transcricao-timeline-empty"
      >
        Nenhum histórico disponível.
      </Typography>
    );
  }

  return (
    <ol className="transcricao-timeline" aria-label="Histórico da solicitação">
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;
        const isAlertCurrent = step.state === 'current' && step.variant === 'alert';

        return (
          <li
            key={step.id}
            className={`transcricao-timeline-step ${stateClassName[step.state]} ${
              isAlertCurrent ? 'transcricao-timeline-step--alert' : ''
            }`}
          >
            <div className="transcricao-timeline-marker-column">
              <StatusMarkerIcon
                variant={step.markerVariant}
                state={step.state}
                size={markerSize}
                ariaLabel={step.state === 'current' ? step.title : undefined}
              />
              {!isLast && <span className="transcricao-timeline-line" aria-hidden="true" />}
            </div>

            <div className="transcricao-timeline-content">
              <Typography
                component="p"
                style={accessibility.textStyleAccessibility}
                className="transcricao-timeline-title"
              >
                <strong>{step.title}</strong>
              </Typography>
              {step.description && (
                <Typography
                  component="p"
                  style={accessibility.textStyleAccessibility}
                  className="transcricao-timeline-description"
                >
                  {step.description}
                </Typography>
              )}
              {step.date && (
                <Typography
                  component="p"
                  style={accessibility.textStyleAccessibility}
                  className="transcricao-timeline-date"
                >
                  {step.date}
                </Typography>
              )}

              {step.showResolver && onResolver && (
                <div className="transcricao-timeline-action">
                  <DefaultButton text="RESOLVER" onClick={onResolver} />
                </div>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default TranscricaoHistoricoTimeline;
